import { render } from "./GameThreeWin.vue?vue&type=template&id=978a8000"
import script from "./GameThreeWin.vue?vue&type=script&lang=js"
export * from "./GameThreeWin.vue?vue&type=script&lang=js"

import "./GameThreeWin.vue?vue&type=style&index=0&id=978a8000&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__